import firebase from 'firebase';
import { firebaseAuth , firebaseDb } from '../firebase';
import { getAuth, isAuthenticated } from './selectors'
import {
  AUTH_CREATE_STUDENT_RECORD_SUCCESS,
  AUTH_CREATE_STUDENT_RECORD_FAILURE,
  AUTH_LOAD_STUDENT_RECORD_SUCCESS,
  AUTH_LOAD_STUDENT_RECORD_FAILURE,
  INIT_AUTH,
  SIGN_IN_ERROR,
  SIGN_IN_SUCCESS,
  SIGN_OUT_SUCCESS
} from './action-types';



//=============================
// INIT ALL AUTH --> LOAD STUDENT RECORD
//=============================
export function initAuthAndLoadStudents(user) {
  return (dispatch, getState) => {
    dispatch(initAuth(user))
    if (isAuthenticated(getState())) {
      return dispatch(loadStudentRecordForLoggedInUser())
    }
    return Promise.resolve()
  }
}

export function initAuth(user) {
  return {
    type: INIT_AUTH,
    payload: user
  };
}
//=============================
// EMAIL --> LOAD STUDENT RECORD --> CREATE STUDENT RECORD
//=============================
export function emailAuthenticateAndHandleStudentDB(credentials) {
  return (dispatch) => {
    if (credentials.passwordConfirmation) {
      return dispatch(signUpUserWithEmail(credentials))
        .then(() => dispatch(loadStudentRecordForLoggedInUser()))
        .then(() => {
          setTimeout(() => {
            dispatch(createStudentRecordForLoggedInUser())
          }, 1000)
        })
    }
    else {
      return dispatch(signInUserWithEmail(credentials))
        .then(() => dispatch(loadStudentRecordForLoggedInUser()))
        .then(() => {
          setTimeout(() => {
            dispatch(createStudentRecordForLoggedInUser())
          }, 1000)
        })
    }

  }
}

//=============================
// OAUTH --> LOAD STUDENT RECORD --> CREATE STUDENT RECORD
//=============================
export function authenticateAndHandleStudentDB(provider) {
  return (dispatch, getState) => {
    return dispatch(authenticate(provider))
      .then(() => dispatch(loadStudentRecordForLoggedInUser()))
      .then(() => {
        setTimeout(() => {
          dispatch(createStudentRecordForLoggedInUser())
        }, 1000)
      })
  }
}

export function authenticate(provider) {
  return dispatch => {
    return firebaseAuth.signInWithPopup(provider)
      .then(result => dispatch(signInSuccess(result)))
      .catch(error => dispatch(signInError(error)));
  };
}

export function signInError(error) {
  return {
    type: SIGN_IN_ERROR,
    payload: error
  };
}

export function signInSuccess(result) {
  return {
    type: SIGN_IN_SUCCESS,
    payload: result
  };
}

//=============================
// SIGN OUT
//=============================
export function signOut() {
  return (dispatch, getState) => {
    const auth = getAuth(getState())
    const pathToStudentDB = 'rhodes-students'
    const lookUp = {
      queryChild: "email",
      queryString: auth.email,
      lookUpType: "equalTo"
    }
    firebaseDb.ref(pathToStudentDB)
      .orderByChild(lookUp.queryChild)
      .equalTo(lookUp.queryString)
      .off()
    return firebaseAuth.signOut()
      .then(() => dispatch(signOutSuccess()));
  };
}

export function signOutSuccess() {
  return {
    type: SIGN_OUT_SUCCESS
  };
}
//=============================
// OAUTH PROVIDERS
//=============================
export function signInWithGithub() {
  return authenticate(new firebase.auth.GithubAuthProvider());
}


export function signInWithGoogle() {
  return authenticateAndHandleStudentDB(new firebase.auth.GoogleAuthProvider());
}


export function signInWithTwitter() {
  return authenticateAndHandleStudentDB(new firebase.auth.TwitterAuthProvider());
}
//=============================
// LOAD STUDENT RECORD
//=============================
export function loadStudentRecordForLoggedInUser() {
  return (dispatch, getState) => {
    const auth = getAuth(getState())
    const pathToStudentDB = 'rhodes-students'
    const lookUp = {
      queryChild: "email",
      queryString: auth.email,
      lookUpType: "equalTo"
    }
    return new Promise((resolve, reject) => {
      firebaseDb.ref(pathToStudentDB)
        .orderByChild(lookUp.queryChild)
        .equalTo(lookUp.queryString)
        .on('value', (snapshot) => {
          let value
          snapshot.forEach((snap) => {
            value = snap.val()
            value.key = snap.key
            return true
          })
          dispatch(authLoadStudentRecordSuccess(value))
          resolve(value)
        },
        (error) => {
          dispatch(authLoadStudentRecordFailure(error))
          reject(error)
        })
    })
  }
}

export function authLoadStudentRecordSuccess(student) {
  return {
    type: AUTH_LOAD_STUDENT_RECORD_SUCCESS,
    payload: student
  }
}

export function authLoadStudentRecordFailure(error) {
  return {
    type: AUTH_LOAD_STUDENT_RECORD_FAILURE,
    payload: error
  }
}

//=============================
// CREATE STUDENT RECORD
//=============================
export function createStudentRecordForLoggedInUser() {
  return (dispatch, getState) => {
    const auth = getAuth(getState())
    if (!auth.existsInFirebase) {
      const pathToStudentDB = 'rhodes-students'
      const studentKey = auth.key
      let studentObject = {}
      studentObject = {
        id: auth.id,
      }
      return new Promise((resolve, reject) => {
        firebaseDb.ref(`${pathToStudentDB}/${studentKey}`)
          .update(studentObject, (error) => {
            if (error) {
              dispatch(authCreateStudentRecordFailure())
              reject(error)
            }
            else {
              dispatch(authCreateStudentRecordSuccess({...studentObject, key: studentKey}))
              resolve()
            }
          })
      })
    }
    return Promise.resolve()
  }
}

export function authCreateStudentRecordSuccess(studentObject) {
  return {
    type: AUTH_CREATE_STUDENT_RECORD_SUCCESS,
    payload: studentObject
  }
}

export function authCreateStudentRecordFailure(error) {
  return {
    type: AUTH_CREATE_STUDENT_RECORD_FAILURE,
    payload: error
  }
}

//=============================
// UPDATE STUDENT RECORD
//=============================
export function updateStudentRecord(student, changes) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      firebaseDb.ref(`rhodes-students/${student.key}`).
        update(changes, error => error  ? reject(error) : resolve())
    })

  }
}

//=============================
// NEW
//=============================
export function clickEmailSignUp(credentials) {
  return emailAuthenticateAndHandleStudentDB(credentials)
}

export function clickEmailSignIn(credentials) {
  return emailAuthenticateAndHandleStudentDB(credentials)
}

export function signUpUserWithEmail(credentials) {
  return function(dispatch) {
    return firebaseAuth.createUserWithEmailAndPassword(credentials.email, credentials.password)
      .then(result => dispatch(signInSuccess(result)))
      .catch(error => dispatch(signInError(error)));
  }
}

export function signInUserWithEmail(credentials) {
  return function(dispatch) {
    return firebaseAuth.signInWithEmailAndPassword(credentials.email, credentials.password)
      .then(response => {
        dispatch(signInSuccess(response));
      })
      .catch(error => {
        dispatch(signInError(error));
      });
  }
}






// WEBPACK FOOTER //
// ./src/core/auth/actions.js